import React from "react";
import { lngDetect } from "../../helpers/lngDetect";

export default function InfoCard({ heading, title, image }) {
  const imageUrl = image?.url || image;

  return (
    <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100">
      <p className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3">
        {heading}
      </p>
      <div className="flex items-start gap-4">
        <div className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden bg-gray-100 shadow">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={heading}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">
              No Image
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 break-words leading-snug">
            {lngDetect(title)}
          </h3>
        </div>
      </div>

    </div>
  );
}
